import { useEffect, useRef } from 'react';
import { useRealtimeContext, type RealtimeWijziging } from '../contexts/RealtimeContext';

/**
 * Subscribe to realtime changes on a Supabase table.
 * Automatically invalidates the corresponding TanStack Query keys.
 *
 * @param table - The Supabase table name to watch
 * @param onUpdate - Optional callback fired when a change event occurs on this table;
 *   receives the realtime payload (eventType, new, old) for row-level cache patches
 */
export function useRealtimeInvalidation(
  table: string,
  onUpdate?: (payload: RealtimeWijziging) => void,
): void {
  const { subscribe } = useRealtimeContext();
  const subscribeRef = useRef(subscribe);
  subscribeRef.current = subscribe;
  const onUpdateRef = useRef(onUpdate);
  onUpdateRef.current = onUpdate;

  useEffect(() => {
    const unsubscribe = subscribeRef.current(table, (payload) => {
      onUpdateRef.current?.(payload);
    });
    return unsubscribe;
    // Only re-subscribe when the table name changes
  }, [table]);
}
